import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import {
  getEmpresas,
  postEmpresa,
  deleteEmpresa,
} from '@auteco/services/sostenibilidadService'
import './SostenibilidadEmpresasContainer.css'

const SostenibilidadEmpresasContainer = () => {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [newEmpresaName, setNewEmpresaName] = useState('')

  const columns = [
    { title: 'ID', field: 'id' },
    { title: 'Nombre', field: 'nombre' },
    {
      title: 'Activo',
      field: 'activo',
      render: (rowData) => (rowData.activo === '1' ? 'Sí' : 'No'),
    },
    { title: 'Fecha de Creación', field: 'creacion', type: 'datetime' },
  ]

  const handleGetEmpresas = async () => {
    const response = await getEmpresas()
    if (response && response.empresas) {
      setData(response.empresas)
    }
  }

  const handleDeleteEmpresa = async (id) => {
    const response = await deleteEmpresa(id)
    if (response) {
      handleGetEmpresas()
    }
  }

  const handleAddEmpresa = async () => {
    if (newEmpresaName.trim() === '') {
      return
    }

    const response = await postEmpresa({ nombre: newEmpresaName })
    if (response) {
      setOpen(false) // Cierra el dialog
      setNewEmpresaName('') // Resetea el campo de nombre
      handleGetEmpresas() // Refresca la lista de empresas
    }
  }

  useEffect(() => {
    handleGetEmpresas()
  }, [])

  return (
    <div>
      <MaterialTable
        title="Empresas"
        columns={columns}
        data={data}
        options={{
          headerStyle: {
            backgroundColor: '#f1f1f1',
            color: 'black',
            fontWeight: 'bold',
          },
        }}
        actions={[
          {
            icon: 'delete',
            tooltip: 'Eliminar',
            onClick: (event, rowData) => {
              handleDeleteEmpresa(rowData.id)
            },
          },
        ]}
      />
      <br />

      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Agregar Empresa
      </Button>

      {/* Dialog para agregar empresa */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Agregar Empresa</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Nombre de la Empresa"
            type="text"
            fullWidth
            value={newEmpresaName}
            onChange={(e) => setNewEmpresaName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleAddEmpresa}
            color="primary"
            disabled={!newEmpresaName.trim()}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default SostenibilidadEmpresasContainer
